/**
 * Formats a number as a percentage string with specified precision
 * @param value - The number to format as a percentage (can be null or undefined)
 * @param precision - The number of decimal places to include (default: 1)
 * @returns A formatted percentage string (e.g., "12.5%") or "—" for null/undefined values
 * @example
 * formatPercentage(12.5) // "12.5%"
 * formatPercentage(12.5, 2) // "12.50%"
 * formatPercentage(null) // "—"
 */
export function formatPercentage(
  value: number | null | undefined,
  precision = 1,
): string {
  if (value === undefined || value === null) return "—";
  return `${value.toFixed(precision)}%`;
}
